// extracted by mini-css-extract-plugin
module.exports = {"kyc":"kyc-certification-list_kyc_1lvMt"};